import React from "react";
import { Box, Heading, Text, List, ListItem, Link } from "@chakra-ui/react";
import PublicLayout from "../../components/public/Layout/layout";

const headingColor = "#d35400";

const styles = {
  container: {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    lineHeight: 1.6,
    color: "#333",
    maxWidth: "900px",
    margin: "0 auto",
    padding: "30px",
  },
};

const PrivacyPolicy = () => {
  return (
    <PublicLayout color="black" bg="white">
      <Box sx={styles.container} py={8}>
        <Heading as="h1" size="xl" color={headingColor} borderBottom="2px solid #eee" pb={2} mb={4}>
          Privacy Policy & Child Safety Standards
        </Heading>
        <Text as="p" fontStyle="italic" color="#7f8c8d" mb={6}>
          Last updated: February 04, 2026
        </Text>

        <Text as="p" mb={4}>
          This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your
          information when You use the Service and tells You about Your privacy rights and how the law protects You.
        </Text>
        <Text as="p" mb={6}>
          We use Your Personal data to provide and improve the Service. By using the Service, You agree to the
          collection and use of information in accordance with this Privacy Policy.
        </Text>

        <Heading as="h2" size="lg" color={headingColor} borderBottom="1px solid #eee" mt={8} mb={4}>
          Interpretation and Definitions
        </Heading>
        <Heading as="h3" size="md" color={headingColor} mt={5} mb={3}>
          Definitions
        </Heading>
        <List spacing={2} mb={6}>
          <ListItem><strong>Account:</strong> means a unique account created for You to access our Service.</ListItem>
          <ListItem><strong>Application:</strong> refers to <strong>Asquera Practice</strong>, the software program provided by the Company.</ListItem>
          <ListItem><strong>Company:</strong> (referred to as either "the Company", "We", "Us" or "Our") refers to <strong>Asquera Practice / Rovoid</strong>.</ListItem>
          <ListItem><strong>Country:</strong> refers to Egypt.</ListItem>
          <ListItem><strong>Personal Data:</strong> is any information that relates to an identified or identifiable individual.</ListItem>
          <ListItem><strong>Service:</strong> refers to the Application.</ListItem>
        </List>

        <Heading as="h2" size="lg" color={headingColor} borderBottom="1px solid #eee" mt={8} mb={4}>
          Collecting and Using Your Personal Data
        </Heading>
        <Heading as="h3" size="md" color={headingColor} mt={5} mb={3}>
          Types of Data Collected
        </Heading>
        <Text as="p" mb={4}>
          While using Our Service, We may ask You to provide Us with certain personally identifiable information including,
          but not limited to: Email address, First and last name, Phone number, and Usage Data.
        </Text>
        <Heading as="h3" size="md" color={headingColor} mt={5} mb={3}>
          Use of Your Personal Data
        </Heading>
        <Text as="p" mb={6}>
          The Company may use Personal Data to provide and maintain our Service, manage Your account, and contact You
          regarding updates or security notifications.
        </Text>

        <Heading as="h2" size="lg" color={headingColor} borderBottom="1px solid #eee" mt={8} mb={4}>
          Children's Privacy (Data Collection)
        </Heading>
        <Text as="p" mb={6}>
          Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable
          information from anyone under the age of 13. If We become aware that We have collected Personal Data from anyone
          under the age of 13 without verification of parental consent, We take steps to remove that information from Our
          servers.
        </Text>

        <Heading as="h2" size="lg" color={headingColor} borderBottom="1px solid #eee" mt={8} mb={4}>
          Changes to this Privacy Policy
        </Heading>
        <Text as="p" mb={6}>
          We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy
          Policy on this page.
        </Text>

        <Heading as="h2" size="lg" color={headingColor} borderBottom="1px solid #eee" mt={8} mb={4}>
          Contact Us
        </Heading>
        <Text as="p" mb={3}>If you have any questions about this Privacy Policy, You can contact us:</Text>
        <List spacing={2} mb={6}>
          <ListItem>By email: <strong>asquerapractice@gmail.com</strong></ListItem>
          <ListItem>
            By website:{" "}
            <Link href="https://asquera.com/#callCenter" target="_blank" rel="noopener noreferrer" color="#3498db">
              https://asquera.com/#callCenter
            </Link>
          </ListItem>
        </List>
      </Box>
    </PublicLayout>
  );
};

export default PrivacyPolicy;
